module.exports = __webpack_public_path__ + "static/media/dress-brown.1e76be93.jpg";